class ProductGallery extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('load', this.initSliders.bind(this));
  }

  initSliders() {  
    this.thumbnails = new Swiper('.gallery-thumbs__slider', {
      slidesPerView: 1.8,
      spaceBetween: 4,
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4
        },
      }
    });

    this.gallery = new Swiper('.product-gallery__slider', {
      effect: "fade",
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        prevEl: '.product-gallery-slider__button.prev',
        nextEl: '.product-gallery-slider__button.next'
      },
      pagination: {
        el: ".product-gallery-slider__pagination",
        type: "fraction",
      },
      thumbs: {
        autoScrollOffset: 1,
        swiper: this.thumbnails,
      },
    });
    
    
  }
}

if(!customElements.get('product-gallery')) {
  customElements.define('product-gallery', ProductGallery);
}